import React from "react";
import img1 from "../Image/Rectangle 34625569.png";
import "./Home.css";
import { Link, Navigate, useNavigate } from "react-router-dom";

function Intercerrub() {
  const navigate = useNavigate()
  const backnavi = () => {
    navigate(-1)
  }
  return (
    <div>
      <div className="container-fluid home-banner-div1">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div>
                <img src={img1} className="img-fluid" alt="" />
              </div>
            </div>
            <div className="col-lg-7 home-banner-col2-div1">
              <div className="home-banner-col2-text11">
                <h1>Rub on wax</h1>
                <h4>Select one option</h4>
                <div className="row">
                  <div className="col-12">
                    <div className="home-banner-btn1">
                      <Link to="/intercerwarm">
                        <div className="btn2">
                          <h5>Warm</h5>
                          <p>
                            Air temperature Range: 10°C to -4°C or 50°F to 25°F{" "}
                            <br />
                            Snow temperature Range: 0°C to -6°C or 32°F to 21°F
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-12">
                    <div className="home-banner-btn1">
                      <Link to="/intercerchill">
                        <div className="btn2">
                          <h5>Chill</h5>
                          <p>
                            Air temperature Range: -2°C to -11°C or 28°F to 12°F{" "}
                            <br />
                            Snow temperature Range: -4°C to -12°C or 25°F to
                            10°F
                          </p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="next-btn-div1">
                   <Link onClick={backnavi}>
                                                       <div className="next-btn1">
                                                         <svg
                                                           class="mr-3"
                                                           xmlns="http://www.w3.org/2000/svg"
                                                           width="11"
                                                           height="16"
                                                           viewBox="0 0 11 16"
                                                           fill="none"
                                                         >
                                                           <path
                                                             d="M9 14L3 8L9 2"
                                                             stroke="rgba(0, 0, 0, 0.80)"
                                                             stroke-width="4"
                                                             stroke-linecap="round"
                                                           />
                                                         </svg>{" "}
                                                         Back
                                                       </div>
                                                     </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Intercerrub;
